var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCqt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.708 7.73a3.503 3.503 0 0 0 4.84-3.232A3.497 3.497 0 0 0 26.049 1a3.502 3.502 0 0 0-3.5 3.498 3.495 3.495 0 0 0 2.16 3.232zm-6.698.266V1C9.716 1 3 7.712 3 16s6.717 15 15.01 15v-6.997A8.002 8.002 0 0 1 10 16a8 8 0 0 1 8.01-8.003v16.007c4.427 0 8.009-3.58 8.009-8.004a8 8 0 0 0-8.01-8.004zM25.99 31a3.502 3.502 0 0 1-3.501-3.499 3.497 3.497 0 0 1 3.5-3.497 3.502 3.502 0 0 1 3.5 3.498 3.498 3.498 0 0 1-3.5 3.5z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCqt);
export default __webpack_public_path__ + "static/media/CQT.12e987ab58afe510decbd128283f07d6.svg";
export { ForwardRef as ReactComponent };